interface HexagonMapDemoPathStopTooltipProps {
	title: string;
	description?: string;
}

export function HexagonMapDemoPathStopTooltip({
	title,
	description,
}: HexagonMapDemoPathStopTooltipProps) {
	return (
		<div className="max-w-[14rem] rounded-lg bg-white px-3 py-2 text-left shadow-lg">
			<p className="font-semibold text-[10px] text-slate-900 uppercase tracking-wide">
				{title}
			</p>
			{description ? (
				<p className="mt-1 text-slate-600 text-xs leading-snug">
					{description}
				</p>
			) : null}
		</div>
	);
}
